<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="600"
  >
    <v-card>
      <v-card-text>
        <v-form
          ref="formNewContactoCliente"
          lazy-validation
          @submit.prevent="save()"
        >
          <v-card-title class="pa-2">
            {{ isEdit ? 'Modificar Instalador' : 'Crear Instalador' }}
            <v-spacer />
          </v-card-title>

          <v-row no-gutters>
            <v-col cols="6">
              <v-text-field
                v-model="nombre"
                class="px-2 py-1"
                :rules="[v => !!v || 'El nombre es obligatorio']"
                flat
                label="Nombre"
                outlined
              />
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="primer_apellido"
                label="Apellido paterno"
                type="tel"
                :rules="[v => !!v || 'El apellido paterno es obligatorio']"
                class="px-2 py-1"
                flat
                outlined
              />
            </v-col>

            <v-col cols="6">
              <v-text-field 
                v-model="segundo_apellido"
                class="px-2 py-1"
                flat
                label="Apellido Materno"
                required
                outlined
              />
            </v-col>

            <v-col cols="6">
              <v-text-field 
                v-model="correo"
                class="px-2 py-1"
                flat
                label="Correo"
                required
                outlined
              />
            </v-col>

            <v-col cols="6">
              <v-text-field 
                v-model="numero"
                class="px-2 py-1"
                flat
                label="Celular"
                :rules="[v => !!v || 'El celular es obligatorio']"
                required
                outlined
              />
            </v-col>

            <v-col cols="6">
              <v-select
                v-model="departamento2"
                class="px-2 py-1"
                flat
                label="Departamento"
                :rules="[v => !!v || 'El departamento es obligatorio']"
                required
                :items="departamentos"
                item-text="nombre_ubigeo"
                item-value="id_ubigeo"
                outlined
                @change="onChangedepartamento"
              />
                <!-- :items="departamentos" -->
            </v-col>

            <v-col cols="6">
              <v-select
                v-model="provincia2"
                class="px-2 py-1"
                :rules="[v => !!v || 'La provincia es obligatorio']"
                flat
                :items="provincias"
                item-text="nombre_ubigeo"
                item-value="id_ubigeo"
                label="Provincia"
                required
                outlined
                @change="onChangeProvincia"
              />
            </v-col>

            <v-col cols="6">
              <v-select
                v-model="distrito2"
                class="px-2 py-1"
                flat
                :rules="[v => !!v || 'El distrito es obligatorio']"
                :items="distritos"
                item-text="nombre_ubigeo"
                item-value="id_ubigeo"
                label="Distrito"
                required
                outlined
                @change="onChangeDistrito"
              />
            </v-col>

            <v-col cols="6">
              <v-text-field
                  v-model="direccion"
                  class="px-2 py-1"
                  flat
                  label="Direcion"
                  required
                  outlined
                />
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="dni"
                class="px-2 py-1"
                flat
                label="Dni"
                required
                outlined
              />
            </v-col>

            <v-col cols="6">
              <v-select
                v-model="especializacion"
                class="px-2 py-1"
                flat 
                :items="especializaciones"
                label="Especializacion"
                :rules="[v => !!v || 'El especializacion obligatorio']"
                required
                outlined
              />
            </v-col>

            <v-col cols="6">
              <v-file-input
                      v-if="(!existFoto)"
                      v-model="foto"
                      accept="image/*"
                      label="Foto (Opcional)"
                      outlined
                      required
                    /> 
              <div v-else>
                <v-btn
                  outlined
                  @click="openFile"
                >
                  Ver foto
                </v-btn>
              </div>
              <!-- <v-text-field
                v-model="foto"
                class="px-2 py-1"
                flat
                label="Foto"
                required
                outlined
              /> -->
            </v-col>
          </v-row>

          <v-card-actions class="pa-2">
            <v-btn
              outlined
              @click="close"
            >
              Cancelar
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              type="submit"
              :loading="loading"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
    <show-file
      ref="showFile"
    >
    </show-file>
  </v-dialog>
</template>

<script>

  // import firebase from 'firebase'
  import firebase from 'firebase'
  import 'firebase/storage'
  import ShowFile from './ShowFile.vue'

  // const db = firebase.firestore()
  const storage = firebase.storage()
  const ref = storage.ref()
  // const db = firebase.firestore()

  export default {
    components: {
      ShowFile
    },
    props: {
    
    },
    data () {
      return {
        dialog: false,
        loading: false,
        contact: undefined,
        departamentos: [],
        provincias: [],
        distritos: [],
        nombre: '',
        primer_apellido: '',
        segundo_apellido: '',
        departamento: '',
        departamento2: '',
        provincia: '',
        provincia2: '',
        distrito: '',
        distrito2: '',
        direccion: '',
        dni: '',
        especializacion: '',
        especializaciones: [],
        foto: undefined,
        correo: '',
        numero: '',
        fotoUri: '',
        showUrl: ''
      }
    },
    computed: {
      isEdit () {
        return this.contact === undefined ? false : 'as'
      },
      existFoto () {
        return this.contact?.foto
      },
    },
    mounted () {
      this.departamentos = this.$store.state.departamentos
      this.especializaciones = this.$store.state.especializaciones
      // this.provincias = this.$store.state.provincias
      // this.distritos = this.$store.state.distritos
    },
    methods: {
      onChangedepartamento () {
        this.provincias = this.$store.state.provincias[this.departamento2]

        this.departamentos.forEach(departamento => {
          if (this.departamento2 === departamento.id_ubigeo)
            { this.departamento = departamento.nombre_ubigeo }
        })

        this.distritos = []
      },
      onChangeProvincia () {
        this.distritos = this.$store.state.distritos[this.provincia2]

        this.provincias.forEach(provincia => {
          if (this.provincia2 === provincia.id_ubigeo)
            { this.provincia = provincia.nombre_ubigeo }
        })
      },
      onChangeDistrito () {
        this.distritos.forEach(distrito => {
          if (this.distrito2 === distrito.id_ubigeo)
            { this.distrito = distrito.nombre_ubigeo }
        })
      },
      async open (item) {
        this.dialog = true
        this.contact = item
        if (this.isEdit) {
          this.nombre = item.nombre
          this.primer_apellido = item.primer_apellido
          this.segundo_apellido = item.segundo_apellido
          this.departamento = item.departamento
          this.provincia = item.provincia
          this.distrito = item.distrito
          this.direccion = item.direccion
          this.dni = item.dni
          this.especializacion = item.especializacion
          if (item.foto) {
            this.showUrl = item.foto
          }
          this.correo = item.correo
          this.numero = item.celular
          if (item?.departamento) {
            if (this.departamentos) {
              this.departamentos.forEach(departamento => {
              if (item?.departamento === departamento.nombre_ubigeo)
                { 
                  this.departamento2 = departamento.id_ubigeo
                }
              })
            }
          }
          if (item?.provincia) {
            this.onChangedepartamento()
            if (this.provincias) {
              this.provincias.forEach(provincia => {
              if (item?.provincia === provincia.nombre_ubigeo)
                { 
                  this.provincia2 = provincia.id_ubigeo
                }
              })
            }
          }
          if (item?.distrito) {
            this.onChangeProvincia()
            if (this.distritos) {
              this.distritos.forEach(distrito => {
              if (item?.distrito === distrito.nombre_ubigeo)
                { 
                  this.distrito2 = distrito.id_ubigeo
                }
              })
            }
          }
        }
      },
      close () {
        this.dialog = false
        this.$refs.formNewContactoCliente.reset()
        this.loading = false
      },
      async save () {
        if (this.$refs.formNewContactoCliente.validate() && this.isEdit === false) {
          this.loading = true

          if (this.foto) {
            const archivo = this.foto
            const refImg = ref.child('fotos/instaladores/' + this.dni + archivo.name)
            const metadata = { contentType: 'img/jpeg' }
            await refImg.put(archivo, metadata)
            .then(e => {
            })
  
            await ref.child('fotos/instaladores/' + this.dni + archivo.name).getDownloadURL()
            .then(url => {
              this.fotoUri = url
            })
          }

          const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/instaladores/contacto', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                nombre: this.nombre,
                primer_apellido: this.primer_apellido,
                segundo_apellido: this.segundo_apellido,
                departamento: this.departamento,
                provincia: this.provincia,
                distrito: this.distrito,
                direccion: this.direccion || '',
                dni: this.dni,
                especializacion: this.especializacion,
                foto: this.fotoUri || '',
                correo: this.correo || '',
                celular: this.numero || '',
              })
            })
            const data = await response.json()
            if (data.success) {
              this.fotoUri = ''
            }

            this.close()
            this.$emit('onCreate')
        } else {
          if (this.isEdit && this.$refs.formNewContactoCliente.validate()) {
            this.loading = true

            if (this.foto) {
              const archivo = this.foto
              const refImg = ref.child('fotos/instaladores/' + this.dni + archivo.name)
              const metadata = { contentType: 'img/jpeg' }
              await refImg.put(archivo, metadata)
              .then(e => {
              })
  
              await ref.child('fotos/instaladores/' + this.dni + archivo.name).getDownloadURL()
              .then(url => {
                this.fotoUri = url
              })
            }

            const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/instaladores/contacto/' + this.contact.id, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                nombre: this.nombre,
                primer_apellido: this.primer_apellido,
                segundo_apellido: this.segundo_apellido,
                departamento: this.departamento,
                provincia: this.provincia,
                distrito: this.distrito,
                direccion: this.direccion || '',
                dni: this.dni,
                especializacion: this.especializacion,
                foto: this.fotoUri || '',
                correo: this.correo || '',
                celular: this.numero || '',
              })
            })
            const data = await response.json()
            if (data.success) {
              this.fotoUri = ''
            }
            this.close()
            this.$emit('onCreate')
          }
        }
      },
      openFile () {
        this.$refs.showFile.open(this.showUrl)
      }
    },
  }
</script>
